import { render, staticRenderFns } from "./chat_home.vue?vue&type=template&id=9d1aeab2&scoped=true&"
import script from "./chat_home.vue?vue&type=script&lang=js&"
export * from "./chat_home.vue?vue&type=script&lang=js&"
import style0 from "./chat_home.vue?vue&type=style&index=0&id=9d1aeab2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1aeab2",
  null
  
)

export default component.exports